import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import TextComponent from "../textComponent/TextComponent";
import styles from "./Dropdown.module.css";

const Dropdown = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(props.value);

  useEffect(() => {
    setSelectedValue(props.value);
  }, [props.value]);

  const handleChange = (value) => {
    setSelectedValue(value);
    // Find the selected option object
    const selectedOption = props?.options.find(
      (option) => option.value === value
    );
    if (props?.onChange) {
      props?.onChange(selectedOption); // Pass the whole object back to the parent
    }
  };
  return (
    <div className={`${styles.main_input} ${props?.className}`}>
      <text className={` ${styles.label} ${props?.labelClass} `}>
        <TextComponent
          color={props?.LabelColor ? props?.LabelColor : "var(--black-color)"}
          fontFamily={props?.fontFamily ? props?.fontFamily : "Inter-semibold"}
          padding={'0px'}

        >
          {props?.label}
        </TextComponent>
      </text>
      <div
        className={styles.input}
        style={props.inputStyle}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Select
          value={selectedValue}
          placeholder={props?.placeholder ? props?.placeholder : null}
          open={isOpen}
          suffixIcon={null}
          className={` ${props?.inputClass}  ${styles.inner_input} `}
          style={{
            fontFamily: "Urbanist-regular",
            color: "var(--placeholder-text)",
            fontFamily: props?.fontFamily,
          

          }}
          dropdownStyle={   {
            fontFamily: "Urbanist-regular",
            backgroundColor:'#f7f8f9'
          }}
          
          // defaultValue={"Select role"}
          onChange={handleChange} // Use the new handleChange function
          options={props?.options?.map((option) => ({
            label: option.value,
            // label: (
            //   <TextComponent
            //     style={{
            //       color:
            //         selectedValue == option?.value
            //           ? "var(--black-color)"
            //           : "var(--white-color)",
            //       fontFamily: "Urbanist-semibold",
            //     }}
            //     text={option?.value}
            //   />
            // ), // Label to display in dropdown
            value: option.value, // Value for the onChange trigger
          }))}
        />

        <div
          className={isOpen ? styles.rightIconUp : styles.rightIconDown}
          onClick={props?.onRightIconPress}
        >
          {/* {isOpen ? <IoMdArrowDropup  /> :  */}
          <IoMdArrowDropdown />
          {/* } */}
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
